module.exports = __webpack_public_path__ + "img/bogo-eoas-01.a6176088.svg";